// extracted by mini-css-extract-plugin
export default {"todolist":"TodoList_todolist__6Orlp","form":"TodoList_form__reTqq","todoitemform":"TodoList_todoitemform__gV57Y"};